"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Renderer = void 0;
var three_1 = require("three");
var CSS3DRenderer_1 = require("three/examples/jsm/renderers/CSS3DRenderer");
var Renderer = /** @class */ (function () {
    function Renderer(base) {
        this.base = base;
        this.sizer = this.base.sizer;
        this.canvas = this.base.canvas;
        this.domCanvas = this.base.domCanvas;
        this.scene = this.base.scene;
        this.scene2 = this.base.scene2;
        this.camera = this.base.camera;
        this.setInstances();
    }
    Renderer.prototype.setInstances = function () {
        //instance
        this.instance = new three_1.WebGLRenderer({
            canvas: this.canvas,
            antialias: true,
            preserveDrawingBuffer: true
        });
        this.instance.physicallyCorrectLights = true;
        this.instance.toneMappingExposure = 1.75;
        this.instance.shadowMap.enabled = true;
        this.instance.shadowMap.type = three_1.PCFSoftShadowMap;
        this.instance.setClearColor(0xffffff);
        //instance2
        this.instance2 = new CSS3DRenderer_1.CSS3DRenderer({
            element: this.domCanvas
        });
        this.sizing();
    };
    Renderer.prototype.resize = function () {
        this.sizing();
    };
    Renderer.prototype.sizing = function () {
        //instance
        this.instance.setSize(this.sizer.width, this.sizer.height);
        this.instance.setPixelRatio(this.sizer.pixelRatio);
        //instance2
        this.instance2.setSize(this.sizer.width, this.sizer.height);
    };
    Renderer.prototype.update = function () {
        this.instance.render(this.scene, this.camera.instance);
        this.instance2.render(this.scene2, this.camera.instance);
    };
    return Renderer;
}());
exports.Renderer = Renderer;
